// Centralized permission constants — must mirror /app/backend/rbac.py.
// Importing these everywhere prevents typo bugs and gives a single source of
// truth for the admin SPA.
import { ADMIN_BASE } from "@admin/constants/route";

export const PERMISSIONS = Object.freeze({
  MANAGE_LAWYERS: "manage_lawyers",
  MANAGE_PRICING: "manage_pricing",
  MANAGE_CONSULTATIONS: "manage_consultations",
  MANAGE_REVIEWS: "manage_reviews",
  VIEW_ANALYTICS: "view_analytics",
  MANAGE_USERS: "manage_users",
  MANAGE_ADMINS: "manage_admins",
  MANAGE_ARTICLES: "manage_articles",
  MANAGE_NOTIFICATIONS: "manage_notifications",
});

// Sidebar registry — single source for admin nav. Each entry is keyed on the
// permission needed to see it. Order here = render order. Paths derive from
// ADMIN_BASE so the whole app re-bases when REACT_APP_ADMIN_PATH changes.
export const ADMIN_NAV = [
  { to: `${ADMIN_BASE}`, label: "Dashboard", icon: "LayoutDashboard", exact: true, permission: null },
  { to: `${ADMIN_BASE}/pricing`, label: "Pricing & Offers", icon: "Tags", permission: PERMISSIONS.MANAGE_PRICING },
  { to: `${ADMIN_BASE}/lawyers`, label: "Lawyers", icon: "Briefcase", permission: PERMISSIONS.MANAGE_LAWYERS },
  { to: `${ADMIN_BASE}/applications`, label: "Applications", icon: "Inbox", permission: PERMISSIONS.MANAGE_LAWYERS },
  { to: `${ADMIN_BASE}/kyc`, label: "e-KYC Review", icon: "ShieldCheck", permission: PERMISSIONS.MANAGE_LAWYERS },
  { to: `${ADMIN_BASE}/consultations`, label: "Consultations", icon: "Calendar", permission: PERMISSIONS.MANAGE_CONSULTATIONS },
  { to: `${ADMIN_BASE}/reviews`, label: "Reviews", icon: "Star", permission: PERMISSIONS.MANAGE_REVIEWS },
  { to: `${ADMIN_BASE}/users`, label: "Users", icon: "Users", permission: PERMISSIONS.MANAGE_USERS },
  { to: `${ADMIN_BASE}/analytics`, label: "Analytics", icon: "BarChart3", permission: PERMISSIONS.VIEW_ANALYTICS },
  { to: `${ADMIN_BASE}/team`, label: "Admin Team", icon: "ShieldCheck", permission: PERMISSIONS.MANAGE_ADMINS },
  { to: `${ADMIN_BASE}/security`, label: "Security", icon: "Lock", permission: null },
];
